import React from "react";
import Hero from "../components/Hero";
import About from "../sections/About";
import Schedule from "../sections/Schedule";
import Sponsors from "../sections/Sponsors";
import Register from "../sections/Register";
import Instructors from "../sections/Instructors";
import PastEvents from "../sections/PastEvents";
import Testimonial from "../sections/Testimonial";
function LandingPage() {
  return (
    <main>
      <Hero />
      <About />
      <PastEvents />
      <Schedule />
      <Instructors />
      <Sponsors />
      <Testimonial />
      <Register />
    </main>
  );
}

export default LandingPage;
